import { VCard } from 'vuetify/lib/components/VCard';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        VCard,
        [
          _c(
            "div",
            { staticClass: "text-right pa-2" },
            [
              _vm.hideAssignAllTables
                ? _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "outline-primary" },
                      on: {
                        click: function ($event) {
                          return _vm.openAllTempOwner()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons md-16" }, [
                        _vm._v("done_all"),
                      ]),
                      _vm._v(
                        _vm._s(_vm.$t("botones.boton_report_all_operator"))
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("b-table", {
            staticClass: "text-center",
            style: { "font-size": "11px" },
            attrs: {
              responsive: "",
              hover: "",
              fields: _vm.reportFields,
              items: _vm.gds_report,
              "per-page": _vm.pagination.limit,
              "current-page": _vm.pagination.current,
              "show-empty": "",
              busy: _vm.isBusy,
            },
            scopedSlots: _vm._u([
              {
                key: "table-busy",
                fn: function (scope) {
                  return [_c("strong", [_vm._v(_vm._s(_vm.messageLoading))])]
                },
              },
              {
                key: "empty",
                fn: function (scope) {
                  return [_c("strong", [_vm._v(_vm._s(_vm.messageEmptyList))])]
                },
              },
              {
                key: "cell(object_name)",
                fn: function (row) {
                  return [
                    _c("div", { staticClass: "text-left" }, [
                      _c("b", [
                        _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.changeMetaReport(row.item, true)
                              },
                            },
                          },
                          [_vm._v(_vm._s(row.item.object_name))]
                        ),
                      ]),
                    ]),
                  ]
                },
              },
              {
                key: "cell(actions)",
                fn: function (row) {
                  return [
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.isDataOperator(row.item) ||
                              (!_vm.isDataOperator(row.item) &&
                                row.item.environment === "prod"),
                            expression:
                              "isDataOperator(row.item) || (!isDataOperator(row.item) && row.item.environment === 'prod')",
                          },
                        ],
                        staticClass: "ml-1",
                        attrs: {
                          size: "sm",
                          variant: "outline-primary",
                          title: "Update Metadata",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changeMetaReport(row.item, false)
                          },
                        },
                      },
                      [_c("b-icon", { attrs: { icon: "pencil-fill" } })],
                      1
                    ),
                    _vm.isDataOperator(row.item) &&
                    row.item.environment === "prod"
                      ? _c(
                          "b-button",
                          {
                            staticClass: "ml-1",
                            attrs: {
                              size: "sm",
                              variant: "outline-primary",
                              title: "Set Temporal data operator",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openTempOwner(row.item)
                              },
                            },
                          },
                          [_c("b-icon", { attrs: { icon: "people-fill" } })],
                          1
                        )
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "cell(rol)",
                fn: function (row) {
                  return [
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "b-popover",
                            rawName: "v-b-popover.hover.right",
                            value: "Open",
                            expression: "'Open'",
                            modifiers: { hover: true, right: true },
                          },
                        ],
                        attrs: {
                          id: "'popover-open-pbi-' + " + row.item.report_id,
                          size: "sm",
                          variant: "outline-primary",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.openReport(row.item)
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isDataOperator(row.item),
                                expression: "isDataOperator(row.item)",
                              },
                            ],
                          },
                          [_vm._v("Data operator")]
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.isDataOperator(row.item),
                                expression: "!isDataOperator(row.item)",
                              },
                            ],
                          },
                          [_vm._v("viewer")]
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("pagination-vue", {
        attrs: { pagination: _vm.pagination },
        on: { changePagina: _vm.changePagina },
      }),
      _c(
        "b-modal",
        {
          attrs: { id: _vm.MODAL_NAME_REPORT, size: "xl", "hide-footer": "" },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isReadonly,
                          expression: "!isReadonly",
                        },
                      ],
                    },
                    [_vm._v("Change report metadata")]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isReadonly,
                          expression: "isReadonly",
                        },
                      ],
                    },
                    [_vm._v("Report metadata")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("form-meta-report-datastudio", {
            attrs: {
              item: _vm.data_ds,
              report_id: _vm.data_ds ? _vm.data_ds["report_id"] : "",
              isChangeRequest: _vm.isReadonly
                ? _vm.ACCESS_TYPE_FLOW.ACCESS
                : _vm.ACCESS_TYPE_FLOW.CHANGE_METADATA,
              readonly: _vm.isReadonly,
              showButtons: !_vm.isReadonly,
            },
            on: { onCloseModal: _vm.onCloseModalReport },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        { attrs: { "hide-footer": "", id: _vm.MODAL_NAME_OWNER } },
        [
          _c("template", { slot: "modal-title" }, [
            _vm._v("Assign temporal operator"),
          ]),
          _c(
            "div",
            { staticClass: "d-block" },
            [
              _c("form-assign-temporal-owner", {
                attrs: { tplToWork: _vm.data_ds, type: "report_gds" },
                on: {
                  submitReport: _vm.assignOwner,
                  cancel: function ($event) {
                    return _vm.$bvModal.hide(_vm.MODAL_NAME_OWNER)
                  },
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "b-modal",
        { attrs: { "hide-footer": "", id: _vm.MODAL_NAME_ALL_OWNER } },
        [
          _c("template", { slot: "modal-title" }, [
            _vm._v("Assign report to temporal operator"),
          ]),
          _c(
            "div",
            { staticClass: "d-block" },
            [
              _c("form-assign-temporal-owner", {
                attrs: {
                  type: "report_gds",
                  records: _vm.gds_report,
                  isForAllOwners: true,
                },
                on: {
                  submitReport: _vm.assignAllOwner,
                  cancel: function ($event) {
                    return _vm.$bvModal.hide(_vm.MODAL_NAME_ALL_OWNER)
                  },
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }